import React from "react";
import "./styles.css";
import "../../../styles/Style.css"
import Navbar from "../../../layout/Navbar/Navbar";
import Sidebar from "../../../layout/Sidebar/SideBar";
import Bloc from "../../organisms/Bloc";

export default function BlocTemplate() {
  return (
    <>
      {/* organism */}
      <Navbar />
      {/* organism */}
      <Sidebar />
      {/* organism */}
      <Bloc />
    </>
  );
}

